import React from 'react';

const Quantity = ({ value, onChange }) => {

    return <div>
        <button style={{ border: "1px solid #ccc", borderRadius: 4, padding: 5, background: "white", color: "#333", margin: "0 10px",
            fontSize: 20, cursor: "pointer", width: 30, height: 30, display: "inline-flex", alignItems: "center", justifyContent: "center"

        }} onClick={() => onChange(Math.max(1, value - 1))}>-</button>
        <span>{value}</span>
        <button style={{ border: "1px solid #ccc", borderRadius: 4, padding: 5, background: "white", color: "#333", margin: "0 10px",
            fontSize: 20, cursor: "pointer", width: 30, height: 30, display: "inline-flex", alignItems: "center", justifyContent: "center"

        }} onClick={() => onChange(value + 1)}>+</button>
    </div>;

}
export default Quantity;